<template>
  <div id="top" class="a__top">
    <div class="w__app">
      <!-- トップ画像 -->
      <div class="b__top">
        <div class="top_image">
          <div id="slider">
            <div class="slidewrap">
              <img src="../../assets/logo/weboar_4.png" alt="" class="nosp" />
            </div>
          </div>
          <div class="weboar_logo">
            <img src="../../assets/svg/weboar_logo.svg" />
          </div>
          <div class="top_contents">
            <TextAnime1 v-if="anime1" />
            <TextAnime2 v-if="anime2" />
          </div>
        </div>
        <div class="b__scroll">
          <div class="w__scroll">
            <div class="scroll_lavel">
              <span class="scroll_text"> Scroll Down </span>
            </div>
            <div class="scroll_point"></div>
          </div>
        </div>
      </div>

      <!-- Our Message -->
      <div class="b__content">
        <div class="b__message">
          <div class="b__message_inner">
            <div class="message">
              <div class="msg_text">
                <div class="effect">
                  <i class="fa fa-child fa-5x"></i>
                  <div>
                    <div class="msg_text_inner">
                      <p class="title_red">Our Message</p>
                      <h2 class="message_title">Weboar ってなに？</h2>
                      <p class="content">
                        日進月歩で変化していくWeb業界の荒波を進む推進力としてのオールとなり、
                        お客様に寄り添い共に乗り越えていくという決意。オールの漕ぎ手である社員一人一人を主役として大切にしたいという思い。その2つを合わせ「Web（ウェブ）」と「
                        Oar（オール）」を組み合わせた、
                        「Weboar（ウェブオール）」という社名を付けました。<br />
                        また、イメージキャラクターにはイノシシを採用しています。亥年というキーワードと、猪突猛進の精神を大切にしたいという思いからイノシシとしました。
                      </p>
                    </div>
                  </div>
                </div>
                <div class="effect_2">
                  <i class="fa fa-child fa-5x"></i>
                  <div>
                    <div class="msg_text_bg">
                      <div class="msg_text_bg_inner"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="msg_thumb">
                <div class="msg_thumb_inner"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- 採用情報 -->
        <div class="b__recruit" id="b_recruit">
          <div class="b__recruit_inner innerlem">
            <div></div>
            <div class="b_side">
              <div class="b_side_content">
                <div class="b_side_inner">
                  <p class="subtitle">楽しく働きたい人</p>
                  <h2 class="title">Recruit</h2>
                  <p class="content">
                    仲間と楽しく仕事ができる環境を大切にし、最後までやりきるという強い責任感と思いを持った仲間を求めています。
                  </p>
                </div>
              </div>
            </div>
            <div class="b_content">
              <div class="b_content_image">
                <img src="../../assets/recruit_1.jpg" alt="" class="nosp" />
              </div>
              <div class="b_content_jobinfo">
                <div class="b_content_jobinfo_inner">
                  <div class="effect">
                    <i class="fa fa-child fa-5x"></i>
                    <div>
                      <div class="jobinfo-bg">
                        <div class="jobinfo-bg_inner">
                          <p class="subtitle_white">一緒に働きませんか？</p>
                          <h2 class="title_white">Welcome</h2>
                          <p class="content_white">
                            現在 Weboar では積極的にメンバーを募集しています。
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="effect_2">
                    <i class="fa fa-child fa-5x"></i>
                    <div>
                      <div class="jobinfo-detail">
                        <div class="jobinfo-detail_inner">
                          <hr />
                          <p>フロントエンドエンジニア</p>
                          <hr />
                          <p>バックエンドエンジニア</p>
                          <hr />
                          <p>インフラエンジニア</p>
                          <hr />
                          <p>デザイナー</p>
                          <hr />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="b_content_subinfo">
                <div class="b_content_subinfo_item">
                  <router-link
                    to="/recruit"
                    class="menu_link b_content_subinfo_link"
                  >
                    <div class="b_content_subinfo_item_image">
                      <img src="../../assets/logo/weboar_1.png" />
                    </div>
                    <div class="b_content_subinfo_content">
                      <p class="subtitle">働き方改革</p>
                      <h2 class="title_recruit">Work Style</h2>
                      <p class="content">
                        エンジニアが最高のパフォーマンスを発揮できる働きやすい環境を用意しています。
                      </p>
                      <router-link to="/recruit/#w__benefits" class="menu_link"
                        >詳しく知る</router-link
                      >
                    </div>
                  </router-link>
                </div>
                <div class="b_content_subinfo_item">
                  <router-link
                    to="/recruit"
                    class="menu_link b_content_subinfo_link"
                  >
                    <div class="b_content_subinfo_item_image">
                      <img src="../../assets/benefits/benefits.png" />
                    </div>
                    <div class="b_content_subinfo_content">
                      <p class="subtitle">福利厚生</p>
                      <h2 class="title_recruit">Benefits</h2>
                      <p class="content">
                        充実の福利厚生でエンジニアの嬉しいをサポートします。
                      </p>
                      <router-link to="/recruit/#w__benefits" class="menu_link"
                        >詳しく知る</router-link
                      >
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 会社概要 -->
        <div class="b__company" id="b__company">
          <div class="effect">
            <i class="fa fa-child fa-5x"></i>
            <div>
              <p class="subtitle">会社概要</p>
              <h2 class="title">Company</h2>
            </div>
          </div>
          <div class="effect_2">
            <i class="fa fa-child fa-5x"></i>
            <div>
              <div class="company_image">
                <div id="slider">
                  <div class="slidewrap">
                    <img src="../../assets/company.png" alt="" class="nosp" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="effect_3">
            <i class="fa fa-child fa-5x"></i>
            <div>
              <div class="company_content">
                <hr />
                <div class="company_table">
                  <span class="title">会社名</span>
                  <span>株式会社Weboar / Weboar Inc.</span>
                </div>
              </div>
              <div class="company_content">
                <hr />
                <div class="company_table">
                  <span class="title">経営陣</span>
                  <span>代表取締役　豊田 達也</span>
                </div>
              </div>
              <div class="company_content">
                <hr />
                <div class="company_table">
                  <span class="title">資本金</span>
                  <span>100 万円</span>
                </div>
              </div>
              <div class="company_content">
                <hr />
                <div class="company_table">
                  <span class="title">事業内容</span>
                  <span>
                    ソフトウェア開発<br />
                    スマートフォンアプリケーション開発<br />
                    ウェブサイト制作・デザイン<br />
                    インフラ構築・運用保守<br />
                  </span>
                </div>
              </div>
              <div class="company_content">
                <hr />
                <div class="company_table">
                  <span class="title">所在地</span>
                  <span
                    >〒532-0004<br />大阪府大阪市淀川区西宮原一丁目8-48-307</span
                  >
                </div>
              </div>
              <div class="company_content">
                <hr />
                <div class="company_table">
                  <span class="title bank">主要取引銀行</span>
                  <span>株式会社三菱UFJ銀行</span>
                </div>
                <hr />
              </div>
              <div class="googlemap">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3278.8676313937617!2d135.492210715227!3d34.73373078042602!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e43632777151%3A0xb436e8f226ea25ea!2z44CSNTMyLTAwMDQg5aSn6Ziq5bqc5aSn6Ziq5biC5reA5bed5Yy66KW_5a6u5Y6f77yR5LiB55uu77yY4oiS77yU77yY!5e0!3m2!1sja!2sjp!4v1591802612460!5m2!1sja!2sjp"
                  width="693"
                  height="431"
                  frameborder="0"
                  style="border: 0"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextAnime1 from "../animation/TextAnime1";
import TextAnime2 from "../animation//TextAnime2";
export default {
  components: {
    TextAnime1,
    TextAnime2,
  },
  name: "Top",
  data() {
    return {
      anime1: true,
      anime2: true,
    };
  },
};

$(function () {
  $(".effect div, .effect i").css("opacity", "0");
  $(window).scroll(function () {
    $(".effect").each(function () {
      var imgPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > imgPos - windowHeight + windowHeight / 5) {
        $("i, div", this).css("opacity", "1");
        $("i", this).css({
          "font-size": "100px",
          padding: "0 20px 40px",
        });
      }
    });
  });
});

$(function () {
  $(".effect_2 div, .effect_2 i").css("opacity", "0");
  $(window).scroll(function () {
    $(".effect_2").each(function () {
      var imgPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > imgPos - windowHeight + windowHeight / 5) {
        $("i, div", this).css("opacity", "1");
        $("i", this).css({
          "font-size": "100px",
          padding: "0 20px 40px",
        });
      }
    });
  });
});

$(function () {
  $(".effect_3 div, .effect_2 i").css("opacity", "0");
  $(window).scroll(function () {
    $(".effect_3").each(function () {
      var imgPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > imgPos - windowHeight + windowHeight / 5) {
        $("i, div", this).css("opacity", "1");
        $("i", this).css({
          "font-size": "100px",
          padding: "0 20px 40px",
        });
      }
    });
  });
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*bxsliderの外側部分の記述*/
#slider {
  width: 100%;
  height: 100%;
  vertical-align: middle;
  overflow: hidden;
  z-index: -999;
}

/*bxsliderに配置する画像のプロパティ*/
.a__top .b__recruit_inner .b_content .b_content_image img {
  /*30秒かけてズームイン・アウトを永遠に繰り返す*/
  animation: animationZoom 15s ease-in-out 0s infinite normal;
  border-radius: 20px;
}

.bx-viewport {
  height: 100% !important;
}

/*拡大した画像のはみ出した部分を隠すためのクラス*/
.slidewrap {
  width: 100%;
  height: 100% !important;
  /* overflow: hidden; */
}

/*イメージをズームさせるCSS3アニメーション*/
@keyframes animationZoom {
  50% {
    transform: scale(1.1);
  }
}

.effect i {
  padding: 0 !important;
  transition: 0.2s;
}

.effect div {
  transition: 0.2s;
  transition-delay: 0.2s;
}

.effect_2 i {
  padding: 0 !important;
  transition: 0.4s;
}
.effect_2 div {
  transition: 0.4s;
  transition-delay: 0.4s;
}

.effect_3 i {
  padding: 0 !important;
  transition: 0.3s;
}
.effect_3 div {
  transition: 0.3s;
  transition-delay: 0.3s;
}

.w__box {
  transition: 1.5s all cubic-bezier(0.39, 0.575, 0.565, 1);
}
.a__top {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.a__top .header {
  display: none;
}

.a__top .w__app {
  width: 100%;
  height: 100%;
}

.a__top .w__app .b__top {
  display: flex;
  position: relative;
}

.a__top .b__top .top_image {
  width: 94%;
  height: calc(100vh - 1.42857em * 2);
  background-image: url("../../assets/top_image.png");
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: cover;
  border-radius: 0 15px 15px 0;
  position: relative;
  min-width: 400px;
}

.a__top .b__top .top_image .slidewrap {
  border-radius: 0 15px 15px 0;
}

.a__top .b__top .top_image .weboar_logo {
  position: absolute;
  top: 30px;
  bottom: 0;
  left: 0;
  right: 10px;
  margin: auto;
  height: 22rem;
  width: 70%;
}

.a__top .b__top .top_image .slidewrap img {
  width: 100%;
  height: 100%;
  border-radius: 0 15px 15px 0;
}

.a__top .b__top .top_image .top_contents {
  position: absolute;
  bottom: 46px;
  left: 82px;
  text-align: left;
}

.a__top .b__top .top_image .top_contents .TextAnime1 {
  margin-top: 18px;
}

.a__top .b__top .top_image .top_contents p.top_content {
  font-size: 18px;
  color: #fff;
  font-weight: bold;
}

.a__top .b__scroll {
  width: 6%;
  height: 21px;
  border-radius: 10.5px;
  font-size: 10px;
  color: #b55746;
  margin-top: 520px;
  position: absolute;
  right: 0;
  bottom: 20%;
}

.a__top .b__scroll .w__scroll {
  padding-bottom: 8em;
  position: relative;
  display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-align: end;
  align-items: flex-end;
  flex-wrap: wrap;
  margin: 0 auto;
  -ms-writing-mode: vertical-rl;
  -ms-writing-mode: tb-rl;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -moz-align-items: flex-end;
  -ms-align-items: flex-end;
  -webkit-box-align: end;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -moz-writing-mode: vertical-rl;
  writing-mode: vertical-rl;
  -webkit-writing-mode: vertical-rl;
}

.a__top .b__scroll .w__scroll::before {
  height: 800px;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(60%, #e6e6e6),
    to(rgba(230, 230, 230, 0))
  );
  background: -webkit-linear-gradient(#e6e6e6 60%, rgba(230, 230, 230, 0) 100%);
  background: linear-gradient(#e6e6e6 60%, rgba(230, 230, 230, 0) 100%);
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 0;
  margin: 0 auto;
  width: 1px;
  content: "";
}

.a__top .b__scroll .w__scroll .scroll_lavel {
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  width: 2em;
  height: 7.7em;
  color: rgb(255, 255, 255);
  letter-spacing: 0.03em;
  font-weight: 700;
  font-family: acumin-pro, YuGothic, 游ゴシック, "ヒラギノ角ゴ Pro W3",
    "Hiragino Kaku Gothic Pro", Osaka, メイリオ, Meiryo, "ＭＳ Ｐゴシック",
    sans-serif;
  line-height: 1;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  margin: 0px auto;
  border-radius: 20px;
  background: #b55746;
  z-index: 90;
}

.a__top .b__scroll .w__scroll .scroll_lavel span.scroll_text {
  padding-left: 2px;
}

.a__top .b__scroll .w__scroll .scroll_point {
  bottom: 6.5rem;
  -webkit-animation: scroll-point 2.6s ease-out infinite;
  animation: scroll-point 2.6s ease-out infinite;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  position: absolute;
  left: 50%;
  z-index: 3;
  margin-left: -3.5px;
  width: 7px;
  height: 7px;
}

.a__top .b__scroll .w__scroll .scroll_point::before {
  z-index: 0;
  background: rgba(0, 0, 0, 0.08);
  -webkit-animation: scroll-point-zoom 2s ease-out infinite;
  animation: scroll-point-zoom 2s ease-out infinite;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -ms-border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0px;
  width: 100%;
  height: 100%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #b55746;
  content: "";
  -ms-border-radius: 50%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  vertical-align: inherit;
  text-decoration: inherit;
}

.a__top .b__scroll .w__scroll .scroll_point::after {
  position: absolute;
  top: 0;
  left: 0px;
  width: 100%;
  height: 100%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #b55746;
  content: "";
  -ms-border-radius: 50%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  vertical-align: inherit;
  text-decoration: inherit;
}

@keyframes scroll-point {
  0% {
    bottom: 6.5rem;
    opacity: 0;
  }

  20% {
    opacity: 1;
  }
  40% {
    bottom: 0;
    opacity: 1;
  }
  70% {
    opacity: 0;
  }
  100% {
    bottom: 0;
    opacity: 0;
  }
}

@keyframes scroll-point-zoom {
  0% {
    transform: scale(1, 1);
    background: rgba(0, 0, 0, 0.08);
  }

  50% {
    opacity: 1;
    background: rgba(0, 0, 0, 0.08);
  }

  100% {
    transform: scale(4, 4);
    opacity: 0;
    background: rgba(0, 0, 0, 0.08);
  }
}

.a__top .b__scroll a {
  padding-top: 70px;
  position: absolute;
  bottom: 8px;
  right: -5px;
  padding-bottom: 25px;
  text-decoration: none;
  color: #b55746;
}
.a__top .b__scroll a span {
  position: absolute;
  bottom: 110px;
  right: 29px;
  width: 20px;
  height: 20px;
  margin-left: -12px;
  border-left: 1px solid #333;
  border-bottom: 1px solid #333;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-animation: sdb 1.5s infinite;
  animation: sdb 1.5s infinite;
  box-sizing: border-box;
}
@-webkit-keyframes sdb {
  0% {
    -webkit-transform: rotate(-45deg) translate(0, 0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    -webkit-transform: rotate(-45deg) translate(-20px, 20px);
    opacity: 0;
  }
}
@keyframes sdb {
  0% {
    transform: rotate(-45deg) translate(0, 0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: rotate(-45deg) translate(-20px, 20px);
    opacity: 0;
  }
}

.a__top .b__content {
  border-left: #d8d8d8 solid 1px;
  padding-bottom: 90px;
}

.a__top .b__message {
  margin-top: 20px;
  overflow: visible;
  display: block;
  position: relative;
}

.a__top .b__message::before {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  content: "";
  vertical-align: inherit;
  text-decoration: inherit;
  box-sizing: inherit;
}

.a__top .b__message .message {
  padding-top: 5em;
  padding-bottom: 14.14286em;
  position: relative;
  z-index: 1;
  display: -webkit-flex;
  justify-content: space-between;
  max-width: inherit;
}

.a__top .b__message .message .msg_text {
  z-index: 1;
  order: 2;
  -webkit-box-ordinal-group: 2;
  margin-right: 0;
  margin-left: auto;
  width: 50%;
  position: relative;
}

.a__top .b__message .message .msg_text .msg_text_inner {
  position: relative;
  z-index: 10;
  overflow: hidden;
}

.a__top .b__message .message .msg_text .msg_text_inner .message_title {
  text-align: left;
}

.a__top .b__message .message .msg_text .msg_text_bg {
  position: absolute;
  z-index: 0;
  overflow: hidden;
  background: #0e78c4;
}

.a__top .b__message .message .msg_text .msg_text_bg .msg_text_bg_inner {
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
    136deg,
    #fee140,
    #fdb960 15%,
    #fcaa6c 33%,
    #fa709a
  );
}

.a__top .b__message .message .msg_text .msg_text_bg .msg_text_bg_inner::after {
  z-index: 1;
  background-image: url(../../assets/svg/logo_1.svg);
  background-position: left 0px bottom 28px;
  background-repeat: no-repeat;
  mix-blend-mode: color-burn;
  position: absolute;
  bottom: 30px;
  left: 36px;
  width: 38%;
  height: 100%;
  border-radius: 20px;
  content: "";
  opacity: 0.16;
  vertical-align: inherit;
  text-decoration: inherit;
}

.a__top .b__message .message .msg_thumb {
  z-index: 10;
}

.a__top .b__message .message .msg_thumb .msg_thumb_inner {
  position: relative;
  width: 100%;
  height: 100%;
}

.a__top .b__recruit {
  overflow: visible;
  display: block;
  position: relative;
}

.a__top .b__recruit:before {
  content: "";
  position: absolute;
  bottom: 10px;
  left: 0;
  display: block;
  width: 84.5%;
  height: 21.64286em;
  background: #fff8f0;
  text-decoration: inherit;
}

.a__top .b__recruit_inner {
  position: relative;
  display: flex;
}

.a__top .b__recruit_inner .b_side {
  position: relative;
  z-index: 13;
}

.a__top .b__recruit_inner .b_side .b_side_content {
  width: 219.75px;
  position: sticky;
}

.a__top .b__recruit_inner .b_side .b_side_inner {
  padding-right: 3.92857em;
  padding-bottom: 16.7em;
  padding-top: 2.92857em;
  text-align: left;
  top: 0;
  position: sticky;
}

.a__top .b__recruit_inner .b_side .b_side_inner h2.title {
  font-size: 32px;
  margin-bottom: 14px;
}

.a__top .b__recruit_inner .b_content {
  padding-top: 3.92857em;
  width: 75%;
  position: relative;
  z-index: 10;
}

.a__top .b__recruit_inner .b_content .b_content_image {
  width: 100%;
  height: 30%;
  z-index: 11;
  position: relative;
}

.a__top .b__recruit_inner .b_content .b_content_image img {
  width: 100%;
  height: 100%;
  animation: animationZoom-data-v-5a5c344d 15s ease-in-out 0s infinite normal;
}

.a__top .b__recruit_inner .b_content .b_content_jobinfo {
  position: relative;
}

.a__top .b__recruit_inner .b_content .b_content_jobinfo::before {
  content: "";
  position: absolute;
  top: -12.5em;
  left: 6em;
  display: block;
  width: 99%;
  height: 30.5em;
  background: #fff8f0;
  text-decoration: inherit;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_jobinfo
  .b_content_jobinfo_inner
  .jobinfo-bg {
  z-index: 0;
  background-image: linear-gradient(
    136deg,
    #fee140,
    #fdb960 15%,
    #fcaa6c 33%,
    #fa709a
  );
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.2);
  color: #fff;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_jobinfo
  .b_content_jobinfo_inner
  .jobinfo-bg
  p.content_white {
  margin-top: 1.42857em;
  padding-right: 7.14286em;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_jobinfo
  .b_content_jobinfo_inner
  .jobinfo-bg::before {
  display: block;
  padding-top: 114%;
  content: "";
  vertical-align: inherit;
  text-decoration: inherit;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_jobinfo
  .b_content_jobinfo_inner
  .jobinfo-bg
  .jobinfo-bg_inner {
  transform: translateY(-50%);
  z-index: 1;
  text-align: left;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_jobinfo
  .b_content_jobinfo_inner
  .jobinfo-bg
  .jobinfo-bg_inner::after {
  background-position: left -20px bottom -50px;
  opacity: 0.14;
  position: absolute;
  bottom: 1px;
  left: 0;
  z-index: 0;
  display: block;
  width: 100%;
  height: 11.42857em;
  /* background-image: url(./../assets/svg/logo_3.svg); */
  background-repeat: no-repeat;
  content: "";
  mix-blend-mode: color-burn;
  vertical-align: inherit;
  text-decoration: inherit;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_jobinfo
  .b_content_jobinfo_inner
  .jobinfo-detail {
  position: relative;
  margin-right: 0;
  margin-left: auto;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_jobinfo
  .b_content_jobinfo_inner
  .jobinfo-detail
  .jobinfo-detail_inner {
  margin: 0;
  padding: 0;
  text-align: left;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_jobinfo
  .b_content_jobinfo_inner
  .jobinfo-detail
  .jobinfo-detail_inner
  hr {
  background-color: #f7b987;
  border-style: none;
  height: 1px;
  margin: 0;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_jobinfo
  .b_content_jobinfo_inner
  .jobinfo-detail
  .jobinfo-detail_inner
  p {
  margin: 25px 0;
}

.a__top .b__recruit_inner .b_content .b_content_subinfo {
  position: relative;
  z-index: 10;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-box-pack: justify;
}

.a__top .b__recruit_inner .b_content .b_content_subinfo::before {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: block;
  box-sizing: content-box;
  padding-left: 6.07143em;
  width: 100%;
  height: 100%;
  border-radius: 20px 0 0 20px;
  background: #fff;
  vertical-align: inherit;
  text-decoration: inherit;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_subinfo
  .b_content_subinfo_item {
  position: relative;
  z-index: 10;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_subinfo
  .b_content_subinfo_item:hover
  a.b_content_subinfo_link
  .b_content_subinfo_item_image {
  transform: scale(0.88);
  transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    border-radius 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), box-shadow 0.3s;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_subinfo
  .b_content_subinfo_item
  a.b_content_subinfo_link {
  background-color: transparent;
  position: relative;
  outline: 0;
  color: #222;
  text-decoration: none;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_subinfo
  .b_content_subinfo_item
  a.b_content_subinfo_link
  .b_content_subinfo_item_image {
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 5px 20px transparent;
  transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    border-radius 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), box-shadow 0.3s;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_subinfo
  .b_content_subinfo_item
  a.b_content_subinfo_link
  .b_content_subinfo_item_image
  img {
  border-style: none;
  width: 100%;
  border: none;
  vertical-align: top;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_subinfo
  .b_content_subinfo_item
  .b_content_subinfo_content {
  text-align: left;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_subinfo
  .b_content_subinfo_item
  .b_content_subinfo_content
  a {
  display: inline-block;
  /* padding: 2px 0; */
  color: #b55746;
  /* overflow: hidden; */
  position: relative;
  text-decoration: none;
  font-size: 12px;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_subinfo
  .b_content_subinfo_item
  .b_content_subinfo_content
  a::after {
  position: absolute;
  bottom: -4px;
  left: 0;
  content: "";
  width: 100%;
  height: 1px;
  background: #b55746;
  transform: scale(0, 1);
  transform-origin: left top;
  transition: transform 0.3s;
}

.a__top
  .b__recruit_inner
  .b_content
  .b_content_subinfo
  .b_content_subinfo_item
  .b_content_subinfo_content
  a:hover::after {
  transform: scale(1, 1);
}

.a__top .b__company {
  margin-top: 90px;
  position: relative;
  justify-content: center;
  margin-right: auto;
  margin-left: auto;
  padding-right: 5em;
  padding-left: 5em;
  max-width: 1250px;
}

.a__top .b__company p.subtitle {
  margin-bottom: 3px;
}

.a__top .b__company h2.title {
  margin: 0 0 24px;
}

.a__top .b__company .company_image {
  height: 100%;
  border-radius: 20px;
  margin: 0 auto 36px;
  width: 67.5%;
}

.a__top .b__company .company_image .slidewrap {
  border-radius: 20px;
}

.a__top .b__company .company_content {
  margin: 0 auto;
  width: 67.5%;
}

.a__top .b__company .company_content hr {
  width: 100%;
  height: 1px;
  border-style: none;
  background-color: #f9eadb;
  margin: 0;
}

.a__top .b__company .company_content .company_table {
  justify-content: right;
  display: flex;
  flex-wrap: wrap;
  margin: 26px 0;
  text-align: left;
}

.a__top .b__company .company_content .company_table span {
  color: #333;
  line-height: 1.6;
}

.a__top .b__company .company_content .company_table .title {
  width: 190px;
  text-align: left;
}

.a__top .b__company .company_image .slidewrap img {
  width: 100%;
  border-radius: 20px;
}

.wrapper {
  background-color: #ccc;
  padding: 300px;
  height: 200vh;
  width: 200vw;
}
.sticky {
  background-color: #009688;
  width: 50vw;
  height: 50vh;
  position: -webkit-sticky; /* Safariに対応する */
  position: sticky; /* 要素を固定/解除する */
  top: 0; /* 縦方向の閾値 */
  left: 0; /* 横方向の閾値 */
}

.googlemap iframe,
.googlemap object,
.googlemap embed {
  width: 67.5%;
  margin: 0 auto;
  margin-top: 40px;
  border-radius: 20px;
}

@media screen and (max-width: 1024px) {
  .a__top .b__scroll {
    display: none;
  }

  .a__top .b__top .top_image .slidewrap {
    border-radius: 0;
  }

  .a__top .b__top .top_image {
    height: calc(94vh - 1.42857em * 2);
  }

  .a__top .b__company .company_image {
    width: 85%;
  }

  .a__top .b__company {
    padding-right: 3em;
    padding-left: 3em;
  }

  .a__top .b__company .company_content {
    width: 85%;
  }

  .googlemap iframe,
  .googlemap object,
  .googlemap embed {
    width: 85%;
  }

  .a__top .b__message .message .msg_text {
    width: 60%;
  }

  .b__recruit .innerlem {
    padding: 0 3em;
  }

  .a__top .b__recruit_inner .b_side .b_side_inner {
    padding-top: 4em;
    padding-bottom: 25.64286em;
  }

  .a__top .b__recruit:before {
    bottom: -90px;
  }

  .a__top .b__top .TextAnime1 span {
    font-size: 48px;
  }

  .a__top .b__top .TextAnime2 span {
    font-size: 16px;
  }
}

@media screen and (max-width: 768px) {
  .a__top .b__message .w__message .b_message {
    width: 60%;
  }

  .a__top .b__recruit {
    padding: 0;
  }

  .a__top .b__recruit .w__recruit .w_contents {
    width: 100%;
  }

  .a__top .b__recruit .w__recruit .w_title .recruit_title {
    display: block;
    text-align: left;
    padding-bottom: 20px;
    width: 100%;
  }

  .a__top .b__recruit .w__recruit .w_title {
    width: 100%;
    padding: 0 24px;
  }

  .a__top .b__recruit .w_types .job_type {
    left: 174px;
    box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.2);
  }

  .a__top .w__app .b__recruit .b__recruit_contents .b__cards {
    padding: 3em 1em 7em;
  }

  .a__top .b__top .top_image .top_contents {
    bottom: 40px;
    left: 32px;
  }

  .a__top .b__company {
    padding-right: 0;
    padding-left: 0;
  }

  .a__top .b__company .company_image {
    width: 100%;
    border-radius: 0;
  }

  .a__top .b__recruit_inner .b_content .b_content_image img {
    border-radius: 0px;
  }
}

@media screen and (min-width: 769px) {
  .a__top .b__message::before {
    width: 84.5%;
    height: 38em;
    background: #fff8f0;
  }

  .a__top .b__message .message .msg_text .msg_text_inner {
    padding: 7.1em 7.14286em;
    padding-right: 5.71429em;
    border-radius: 20px 0 0 20px;
    background: #fff;
    box-shadow: 0 0 50px rgba(0, 0, 0, 0.2);
  }

  .a__top .b__message .message .msg_text .msg_text_bg {
    top: calc(3.14286em + 7.5rem);
    left: -25em;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    box-shadow: 0 0 50px rgba(0, 0, 0, 0.2);
  }

  .a__top .b__message .message .msg_thumb {
    position: absolute;
    top: 1.64286em;
    left: 0;
    order: 1;
    width: 55.6%;
    height: calc(100% - 1.64286em);
    -webkit-box-ordinal-group: 1;
  }

  .a__top .b__recruit_inner {
    display: -webkit-flex;
    justify-content: space-between;
    padding-bottom: 11.42857em;
    -webkit-flex-wrap: wrap;
    -webkit-box-pack: justify;
  }

  .b__recruit .innerlem {
    box-sizing: content-box;
    margin-right: auto;
    margin-left: auto;
    padding-right: 5.71429em;
    padding-left: 5em;
    max-width: 1250px;
  }

  .a__top .b__recruit_inner .b_side {
    width: 25%;
  }

  .a__top .b__recruit_inner .b_side .b_side_content {
    top: 0px;
    position: sticky;
  }

  .a__top .b__recruit_inner .b_side .b_side_inner {
    padding-right: 3.92857em;
    padding-bottom: 16em;
  }

  .a__top .b__recruit_inner .b_content {
    padding-top: 3.92857em;
    width: 75%;
  }

  .a__top .b__recruit_inner .b_content .b_content_image {
    border-radius: 20px;
    box-shadow: 0 0 50px rgba(0, 0, 0, 0.2);
  }

  .a__top .b__recruit_inner .b_content .b_content_jobinfo {
    margin-top: 5em;
    padding-top: 2em;
    padding-bottom: 5.2em;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner {
    position: relative;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg {
    position: absolute;
    top: calc(-4em);
    left: 0;
    width: 56.5%;
    height: 100%;
    border-radius: 20px;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg
    h2.title_white {
    margin: 8px 0 14px;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg
    p.content_white {
    margin-top: 0;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg::after {
    background-position: left 43px bottom 0px;
    opacity: 0.14;
    position: absolute;
    bottom: 1px;
    left: 0;
    z-index: 0;
    display: block;
    width: 100%;
    height: 9.5em;
    background-image: url(../../assets/svg/logo_3.svg);
    background-repeat: no-repeat;
    content: "";
    mix-blend-mode: color-burn;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg
    .jobinfo-bg_inner {
    position: absolute;
    top: 36%;
    padding: 4em;
    transform: translateY(-50%);
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-detail {
    padding: 4.14286em 4em;
    width: 45%;
    border-radius: 20px;
    background: #ffeee1;
  }

  .a__top .b__recruit_inner .b_content .b_content_subinfo {
    padding-bottom: 3.5em;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_subinfo
    .b_content_subinfo_item {
    width: 47%;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_subinfo
    .b_content_subinfo_item
    .b_content_subinfo_content {
    margin-top: 2.2em;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_subinfo
    .b_content_subinfo_item
    .b_content_subinfo_content
    .subtitle {
    margin-bottom: 8px;
    margin: 2px 0 7px;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_subinfo
    .b_content_subinfo_item
    .b_content_subinfo_content
    h2.title_recruit {
    font-size: 23px;
    margin: 8px 0 14px;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_subinfo
    .b_content_subinfo_item
    .b_content_subinfo_content
    p.bwn_link {
    margin-top: 0.33333em;
    font-size: 12px;
  }
}

@media screen and (min-width: 1440px) {
  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg::after {
    height: 13em;
  }
}

@media screen and (max-width: 1240px) {
  .a__top .b__message .message .msg_text .msg_text_inner {
    padding: 4.1em 4.14286em;
    padding-right: 3.71429em;
  }

  .a__top .b__message .message .msg_text .msg_text_bg {
    top: calc(1.14286em + 7.5rem);
    left: -18em;
  }

  .a__top .b__recruit_inner .b_side .b_side_inner {
    padding-right: 3.92857em;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg
    .jobinfo-bg_inner {
    padding: 2em;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-detail {
    padding: 3em 3em;
  }
}

@media screen and (max-width: 768px) {
  .a__top .b__top .TextAnime2 span {
    font-size: 8px;
  }

  .effect i {
    padding: 0 !important;
    transition: none;
  }

  .effect div {
    transition: none;
    transition-delay: .none;
  }

  .effect_2 i {
    padding: 0 !important;
    transition: none !important;
  }
  .effect_2 div {
    transition: none !important;
    transition-delay: none !important;
  }

  .effect_3 i {
    padding: 0 !important;
    transition: none;
  }
  .effect_3 div {
    transition: none;
    transition-delay: none;
  }

  .a__top .b__top .top_image {
    width: 100%;
    min-width: 0;
  }

  .a__top .b__top .top_image #slider .slidewrap img {
    height: 100% !important;
    border-radius: 0;
  }

  .a__top .b__top .top_image .top_contents .item {
    font-size: 30px;
  }

  .a__top .b__message {
    position: relative;
    z-index: 10;
    margin-top: 0;
  }

  .a__top .b__message .b__message_inner {
    position: relative;
  }

  .a__top .b__message .b__message_inner .message {
    padding-top: 1.78571em;
    padding-bottom: 0;
  }

  .a__top .b__message .b__message_inner .message .msg_text {
    position: relative;
    z-index: 20;
    width: calc(100vw - 1.78571em);
  }

  .a__top .b__message .b__message_inner .message .msg_text .msg_text_inner {
    padding: 3em 2.85714em;
    padding-right: 3.21429em;
    border-radius: 20px 0 0 0;
    background-color: #fff;
    opacity: 1;
  }

  .a__top .b__recruit_inner .b_side .b_side_inner h2.title {
    font-size: 32px;
    margin: 4px 0;
  }

  .a__top .b__recruit_inner .b_side .b_side_inner p.content {
    font-size: 12px;
    margin: 4px 0;
  }

  .a__top
    .b__recruit
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg
    .subtitle_white {
    font-size: 11px;
    margin: 4px 0;
  }

  .a__top
    .b__recruit
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg
    h2.title_white {
    font-size: 22px;
    margin: 4px 0 8px;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg
    p.content_white {
    font-size: 13px;
    margin: 4px 0;
  }

  .a__top .b__message .message .msg_text .msg_text_bg {
    position: absolute;
    top: 0;
    left: 0;
  }

  .a__top .b__message .message .msg_text .msg_text_bg {
    top: -1.78571em;
    left: -1.78571em;
    width: 80vw;
    opacity: 1;
    height: calc(100% + 1.78571em);
  }

  .a__top
    .b__message
    .b__message_inner
    .message
    .msg_text
    .msg_text_inner
    p.title_red {
    font-size: 11px;
  }

  .a__top
    .b__message
    .b__message_inner
    .message
    .msg_text
    .msg_text_inner
    h2.message_title {
    font-size: 25px;
  }

  .a__top
    .b__message
    .b__message_inner
    .message
    .msg_text
    .msg_text_inner
    p.content {
    font-size: 12px;
  }

  .a__top
    .b__recruit
    .b__recruit_inner
    .b_content
    .b_content_image
    .recruit_image
    #slider
    .slidewrap
    img {
    border-radius: 0;
  }

  .a__top .b__recruit_inner .b_content .b_content_image {
    box-shadow: none;
  }

  .a__top .b__recruit {
    background-color: #fff8f0;
  }

  .a__top .b__recruit .b__recruit_inner {
    box-sizing: border-box;
    padding-right: 1.07143em;
    padding-left: 1.07143em;
    display: block;
  }

  .a__top .b__recruit .b__recruit_inner .b_side {
    padding-bottom: 1em;
  }

  .a__top .b__recruit .b__recruit_inner .b_side::before {
    position: absolute;
    top: 0;
    left: -1.07143em;
    width: calc(100% + 1.07143em * 2);
    height: 100%;
    background: #fff8f0;
    content: "";
  }

  .a__top .b__recruit .b__recruit_inner .b_side .b_side_content {
    width: 100% !important;
  }

  .a__top .b__recruit_inner .b_side .b_side_inner {
    padding-bottom: 0;
    padding-top: 20px;
  }

  .a__top .b__recruit .b__recruit_inner .b_side .b_side_content .b_side_inner {
    padding-right: 1.07143em;
  }

  .a__top .b__recruit .b__recruit_inner .b_content {
    padding-top: 0;
    width: 100%;
  }

  .a__top .b__recruit .b__recruit_inner .b_content .b_content_image {
    left: -1rem;
    width: calc(100% + 1.07143em * 2);
    border-radius: 0;
  }

  .a__top .b__recruit .b__recruit_inner .b_content .b_content_jobinfo {
    margin-top: 3.57143em;
  }

  .a__top
    .b__recruit
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner {
    overflow: hidden;
    border-radius: 20px;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
  }

  .a__top
    .b__recruit
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg {
    opacity: 1;
    animation: none;
  }

  .a__top
    .b__recruit
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg
    .jobinfo-bg_inner {
    padding: 3.21429em 1.07143em;
  }

  .a__top
    .b__recruit
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg::after {
    background-position: left -30px bottom -40px;
    background-size: auto 11.07143em;
    opacity: 0.1;
  }

  .a__top
    .b__recruit
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-detail {
    opacity: 1;
    animation: none;
    background-color: #fff;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg::before {
    padding-top: 0;
  }

  .a__top .b__recruit_inner .b_content .b_content_jobinfo::before {
    display: none;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg
    .jobinfo-bg_inner {
    transform: none;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg
    p.content_white {
    padding-right: 0;
  }

  .a__top
    .b__recruit
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-bg
    .jobinfo-bg_inner {
    padding: 1.78571em 1.07143em;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-detail {
    padding: 1.78571em 1.07143em;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_jobinfo
    .b_content_jobinfo_inner
    .jobinfo-detail
    .jobinfo-detail_inner
    p {
    margin: 1.69231em 0;
    font-size: 13px;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_subinfo
    .b_content_subinfo_item
    .b_content_subinfo_content
    .subtitle {
    font-size: 11px;
    font-weight: normal;
    margin: 4px 0 0;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_subinfo
    .b_content_subinfo_item
    .b_content_subinfo_content
    h2.title_recruit {
    font-size: 22px;
    margin: 4px 0 0;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_subinfo
    .b_content_subinfo_item
    .b_content_subinfo_content
    p.content {
    font-size: 11px;
    margin: 8px 0 0;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_subinfo
    .b_content_subinfo_item
    .b_content_subinfo_content
    p.bwn_link {
    font-size: 10px;
  }

  #slider img {
    animation: none;
    height: auto !important;
    border-radius: 15px;
  }

  .a__top .b__recruit_inner .b_content .b_content_subinfo {
    margin-top: 2.85714em;
    padding-bottom: 4.28571em;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_subinfo
    .b_content_subinfo_item {
    width: 47.5%;
  }

  .a__top
    .b__recruit_inner
    .b_content
    .b_content_subinfo
    .b_content_subinfo_item
    .b_content_subinfo_content {
    margin-top: 1.42857em;
  }

  .a__top .b__recruit_inner .b_content .b_content_subinfo::before {
    background: none;
  }

  .a__top .b__company h2.title {
    font-size: 35px;
    margin: 0px 0 16px;
  }

  .a__top .b__company {
    margin-top: 40px;
    padding-right: 1.07143em;
    padding-left: 1.07143em;
  }

  .a__top .b__company .company_image {
    width: 100%;
    height: auto;
  }

  .a__top .b__company .company_image .slidewrap {
    border-radius: 0;
  }

  .a__top .b__company .company_content {
    width: 100%;
  }

  .a__top .b__company .company_content hr {
    width: 100%;
  }

  .googlemap iframe,
  .googlemap object,
  .googlemap embed {
    width: 100%;
  }

  .a__top .b__company .company_content .company_table span {
    width: 65%;
    font-size: 12px;
  }

  .a__top .b__company .company_content .company_table span.title {
    width: 35%;
    font-weight: bold;
  }

  .a__top .b__recruit .b__recruit_inner .b_content .b_content_jobinfo {
    margin-top: 2em;
  }

  .a__top .b__top .top_image .weboar_logo {
    top: 20%;
  }

  .a__top .b__recruit:before {
    bottom: 0;
  }
}
@media screen and (max-width: 520px) {
  .googlemap iframe,
  .googlemap object,
  .googlemap embed {
    height: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Top.vue